export const SET_CARTS = 'SET_CARTS';
export const SET_CART = 'SET_CART';



export function setCarts(carts) {
    return { type: SET_CARTS, carts };
}

export function setCart(cart) {
    return { type: SET_CART, cart };
}